<template>
  <div class="homeright">
    <div class="title_t">
      <div class="title_m">目录</div>
      <CellGroup>
        <Cell style="border-bottom:1px solid #e8eaec;" title="《起名废急救指南》总目录" to="/artical1" />
        <Cell style="border-bottom:1px solid #e8eaec;" title="《起名废急救指南》序言" to="/articalxu" />
        <Cell style="border-bottom:1px solid #e8eaec;" title="了解现代汉语音韵知识" to="/artical6" />
        <Cell style="border-bottom:1px solid #e8eaec;" title="关于起名、改名的四件法律常识" to="/artical5" />
        <Cell style="border-bottom:1px solid #e8eaec;" title="从古人的字学起名" to="/artical4" />
        <Cell style="border-bottom:1px solid #e8eaec;" title="姓氏文化简介" to="/artical3" />
        <Cell style="border-bottom:1px solid #e8eaec;" title="取名的思维过程" to="/artical2" />
        <Cell style="border-bottom:1px solid #e8eaec;" title="全国及各省重名查询接口汇总" to="/searchname" />
        <Cell style="border-bottom:1px solid #e8eaec;" title="派出所改名需要哪些手续和流程？" to="/changename" />
        <!-- <Cell style="border-bottom:1px solid #e8eaec;" title="关于姓氏的20个冷知识" to="/aboutname" /> -->
      </CellGroup>
    </div>
    <div class="title_min">
      <div class="title_m">小程序二维码</div>
      <div class="minipImg">
        <img src="@/assets/minp.jpg">
      </div>
    </div>
    <div class="title_min">
      <div class="title_m">公众号二维码</div>
      <div class="minipImg">
        <img src="@/assets/gzh.jpg">
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.homeright {
  .title_t {
    padding-top:80px;
    height: 480px;
    background-color: #fff;
    border: 1px #f2f2f2 solid;
    box-shadow: 0 0 3px #ddd;
    .title_m {
      text-align: center;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px #e8eaec solid;
    }
  }
  .title_min {
    margin: 20px 0;
    height: 280px;
    background-color: #fff;
    border: 1px #f2f2f2 solid;
    box-shadow: 0 0 3px #ddd;
    .title_m {
      text-align: center;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px #e8eaec solid;
    }
    .minipImg {
      margin-top:10px;
      text-align: center;
      img {
        height: 210px;
        width: 210px;
      }
    }
  }
}
</style>